import { useState } from "react";
import { Plus } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogFooter,
} from "@/components/ui/dialog";

import { EnhancedAddAssetForm } from "./asset-dialog/EnhancedAddAssetForm";

interface EnhancedAddAssetDialogProps {
  portfolioId: string;
  onAssetAdded: () => void;
  buttonLabel?: string;
  defaultAssetType?: string;
}

export function EnhancedAddAssetDialog({ 
  portfolioId, 
  onAssetAdded,
  buttonLabel = "Add Asset (New)",
  defaultAssetType
}: EnhancedAddAssetDialogProps) {
  const [open, setOpen] = useState(false);

  const handleOpenChange = (isOpen: boolean) => {
    // When dialog state changes, ensure we have a clean state
    console.log('Dialog open state changing to:', isOpen);
    setOpen(isOpen);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" className="ml-2">
          <Plus className="mr-2 h-4 w-4" />
          {buttonLabel}
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[500px] max-w-[90vw]">
        <DialogHeader>
          <DialogTitle>Add Asset to Portfolio</DialogTitle>
          <DialogDescription id="add-asset-desc">
            Search and select an asset, then add it to the current portfolio.
          </DialogDescription>
        </DialogHeader>
        

        
        <EnhancedAddAssetForm
          portfolioId={portfolioId}
          onAssetAdded={onAssetAdded}
          open={open}
          setOpen={setOpen}
          defaultAssetType={defaultAssetType}
        />
      </DialogContent>
    </Dialog>
  );
}
